// 路由校验函数
import user from '@/common/user';
import permission from '@/common/permission';
import { Toast } from 'vant';
import app from '@/common/app';
import config from '@/config';

class checkRouter {
  constructor() {
    // 需要检查小豹哥角色的路由
    this.checkRoleRoute = config.checkRoleRoute;
  }
  // 登录态检查
  loginUser(to) {
    return new Promise(async resolve => {
      const userFlag = await user.checkUserInfo(to.path);
      if (!userFlag) {
        const tips = '登录信息失效';
        Toast(tips);
        let timer = setTimeout(function() {
          app.logonStateFailure('XIANYU-FACADE-10006');
          clearTimeout(timer);
          timer = null;
        }, 2000);
        resolve(false);
        return false;
      }
      resolve(true);
    });
  }
  // 检查是否只有小豹哥
  roleAuth(to) {
    const isCheck = this.checkRoleRoute.some(item => item === to.path);
    if (!isCheck) return true;
    // 如果只有小豹哥角色，校验不通过
    if (
      permission.value.roleArr.length === 1 &&
      permission.value.roleArr[0].value === '3'
    )
      return false;
    return true;
  }
}

export default new checkRouter();
